module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showtable === 'myReport'),
      expression: "showtable === 'myReport'"
    }],
    staticClass: "grid-template"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow is-fullwidth"
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(key) {
    return _c('th', {
      class: {
        active: _vm.sortKey == key
      },
      on: {
        "click": function($event) {
          _vm.sortBy(key), _vm.showSortIcon()
        }
      }
    }, [_c('div', [_vm._v("\n              " + _vm._s(_vm._f("capitalize")(key)) + "\n              ")])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredData), function(entry) {
    return _c('tr', _vm._l((_vm.columns), function(key) {
      return _c('td', {
        class: _vm.GetRiskColor(entry[key])
      }, [_vm._v("\n              " + _vm._s(entry[key]) + "\n            ")])
    }), 0)
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f0bd79c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/layout/tableComponent.vue
// module id = 363
// module chunks = 5